import { Flex, Grid } from '@radix-ui/themes'
import { formatDate } from '@/lib/shipment'
import { Subscription, FlowerCollectionProduct } from '~/api-client/data-contracts'
import { Link } from 'react-router'
import { Button } from '~/components/subscription/button'
import * as styles from './styles.css'

export const AddInBulkCard: React.FC<{
  subscription: Subscription
  inBulkProducts: FlowerCollectionProduct[]
}> = ({ subscription, inBulkProducts }) => {
  if (!subscription) return null

  const date = formatDate(subscription.attributes.next_deliver_at * 1000, 'M/d（E）')
  const products = inBulkProducts.filter((item) => item.attributes.bulk_discounted_price > 0)

  if (products.length === 0) return null

  return (
    <Flex direction="column" align="start" gap="4px" className={styles.card}>
      <h3 className={styles.cardHeading}>{date}お届け分にグッズを追加できます</h3>
      <Flex direction="column" align="start" gap="8px">
        <Grid rows="1" columns="repeat(4, 1fr)" gap="8px" py="8px">
          {products.slice(0, 4).map((item) => (
            <Link key={item.id} to={`/subscription/mypage/bulk`} className={styles.thumbnail} style={{ position: 'relative' }}>
              {item.attributes.bulk_discounted_price < item.attributes.price && <span className={styles.discountLabel}>-20%</span>}
              <img src={item.attributes.image_small_url} className={styles.image} />
            </Link>
          ))}
        </Grid>
        <Button as="a" href="/subscription/mypage/bulk" size="s">
          すべてのグッズを見る
        </Button>
      </Flex>
    </Flex>
  )
}
